import { render, staticRenderFns } from "./EmptySection.vue?vue&type=template&id=47ccd424&scoped=true"
import script from "./EmptySection.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptySection.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EmptySection.vue?vue&type=style&index=0&id=47ccd424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccd424",
  null
  
)

export default component.exports